<template>
  <div class="new-bot">
    <a-modal
      title="添加机器人"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :closable="false"
      :centered="true"
      :destroyOnClose="true"
      cancelText="取消"
      okText="完成"
      width="400px"
      style="height: 100px"
    >
      <p>将二维码的文件名设置为 wxid_xxx.jpg</p>
      <p style="color: red">注意后缀只能为 .jpg</p>
      <div>
        <label class="info" style="width: 30%">二维码</label>
        <a-radio-group v-model="optionVal" @change="onChange">
          <a-radio :value="1"> 本地上传 </a-radio>
          <a-radio :value="2"> 使用图片链接 </a-radio>
        </a-radio-group>
        <div style="margin-top: 10px; margin-left: 60px">
          <a-upload
            v-if="optionVal === 1"
            name="file"
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            action="https://api.zidouad.com/robot/upload_qrcode"
            :beforeUpload="beforeUpload"
            @change="handleChange"
            style="width: 70%; display: inline-flex"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              alt="avatar"
              style="max-width: 100%; max-height: 100%"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
          <div v-if="optionVal === 2">
            <a-input
              v-model="qrcLink"
              placeholder="请输入使用图片链接"
              @change="imgInputChange"
              style="width: 246px"
            />
						<div style="min-height: 30px; margin-top: 10px;">
							<img
								v-if ="qrcLink"
								:src="qrcLink"
								alt="avatar"
								style="max-width: 86px; min-height: 20px"
							/>
						</div>
          </div>
        </div>
      </div>
      <div>
        <label class="info" style="width: 30%">微信号</label>
        <a-input
          :disabled="botUsername === ''"
          v-model="botUsername"
          placeholder="请先上传二维码"
          style="width: 70%; margin: 10px 0 10px 0"
        ></a-input>
      </div>
      <!--<div style="margin: 10px 0 10px 0">-->
      <!--<label class="info" style="width: 40%">是否设为专属</label>-->
      <!--<a-select v-model="vip" style="width: 60%">-->
      <!--<a-select-option value="1"> 是 </a-select-option>-->
      <!--<a-select-option value="0"> 否 </a-select-option>-->
      <!--</a-select>-->
      <!--</div>-->
      <!--<div style="margin: 10px 0 10px 0">-->
      <!--<label class="info" style="width: 40%">客户提供账号</label>-->
      <!--<a-select v-model="doodod" style="width: 60%">-->
      <!--<a-select-option value="1"> 否 </a-select-option>-->
      <!--<a-select-option value="0"> 是 </a-select-option>-->
      <!--</a-select>-->
      <!--</div>-->
      <div>
        <label>种类：</label>
        <a-select style="width: 140px; margin-left: 13px" v-model="type">
          <a-select-option value="1">紫豆机器人</a-select-option>
          <a-select-option value="2">直播机器人</a-select-option>
          <a-select-option value="5">团小蜜机器人</a-select-option>
        </a-select>
      </div>
      <div style="margin-top: 10px">
        <label>微信种类：</label>
        <a-select style="width: 140px; margin-left: 13px" v-model="bot_type">
          <a-select-option value="wechat">微信</a-select-option>
          <a-select-option value="wework">企业微信</a-select-option>
        </a-select>
      </div>
      <div>
        <label class="info" style="width: 30%">备注（可选）</label>
        <a-input
          v-model="remark"
          placeholder="机器人或客户相关的信息"
          style="width: 70%; margin: 10px 0 10px 0"
        ></a-input>
      </div>
      <span> 默认设置为专属机器人，添加机器人后可修改</span>
    </a-modal>
  </div>
</template>

<script>
import AModal from "ant-design-vue/es/modal/Modal";
import AUpload from "ant-design-vue/es/upload/Upload";
function getBase64(img, callback) {
  const reader = new FileReader();
  console.log("getBase64", reader);
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
  // console.log('getBase64', img)
}
export default {
  name: "newBotModal",
  components: { AUpload, AModal },
  props: ["visible"],
  data() {
    return {
      newBotUrlPostFix: "UBot/new_bot",
      confirmLoading: false,
      vip: "1",
      doodod: "0",
      botUsername: "",
      remark: "",
      loading: false,
      imageUrl: "",
      ossUrl: "",
      type: undefined,
      bot_type: "wechat",
      // 1: 本地上传， 2: 使用图片链接
      optionVal: 1,
      qrcLink: '',
			uploadImgName: '',
			linkImgName: ''
    };
  },
  computed: {
    newBotUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.newBotUrlPostFix;
    },
  },
  methods: {
    handleOk() {
      // console.log('handleOk')
      this.onFinish();
    },
    handleCancel() {
      // console.log('handleCancel')
      this.onCancel();
    },
    onFinish() {
      // console.log('onFinish')

      this.confirmLoading = true;
      this.axios
        .post(this.newBotUrl, {
          bot_username: this.botUsername,
          remark: this.remark,
          oss_url: this.optionVal === 1 ? this.ossUrl : this.qrcLink,
          vip: parseInt(this.vip),
          doodod: parseInt(this.doodod),
          type: parseInt(this.type),
          bot_type: this.bot_type,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('绑定成功')
            this.confirmLoading = false;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
          this.$emit("on-finish");
          this.vip = "1";
          this.doodod = "0";
          this.botUsername = "";
          this.remark = "";
          this.imageUrl = "";
          this.ossUrl = "";
        });
    },
    onCancel() {
      // console.log('onCancel')
      this.$emit("on-cancel");
      this.confirmLoading = false;
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          // console.log('callback', imageUrl)
          this.imageUrl = imageUrl;
          this.loading = false;
        });
        console.log("done", info.file);
        const res = info.file.response;
        if (res.err_code === 0) {
          this.ossUrl = res.content.oss_url
          this.botUsername = info.file.name.split(".")[0];
					this.uploadImgName = info.file.name.split(".")[0];
        }
      }
    },
    imgInputChange(){
        let str = this.qrcLink.split('/')
        this.botUsername = str[str.length-1].split('.')[0]
				this.linkImgName = str[str.length-1].split('.')[0]
    },
    beforeUpload(file) {
      // console.log('beforeUpload', file.type)
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("仅支持 jpg/jpeg/png 类型的图片！");
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("图片大小小于 5MB!");
      }
      return isJPG && isLt5M;
    },
    onChange(e) {
      // console.log("radio1 checked", e.target.value);
      this.optionVal = e.target.value
			this.botUsername = this.optionVal === 1 ? this.uploadImgName : this.linkImgName
    },
    test() {
      console.log(this.type);
    },
  },
};
</script>

<style scoped>
</style>
